import { useUserReviews } from '@/scopes/products/user-reviews/hooks'
import { Filters } from './Filters/Filters'
import { List } from './List'
import styles from './Result.module.css'

export function Result() {
  const { isLoading } = useUserReviews()

  if (isLoading) {
    return 'Loading...'
  }

  return (
    <div className={styles.wrapper}>
      <Filters />
      <List />
    </div>
  )
}
